export default __webpack_public_path__ + "static/media/Jaymart.02050699.png";